import { httpClient } from "../utils/http.client";
import { API_ENDPOINTS } from "../config/api.config";

export const authService = {
  getUserType: async (username) => {
    return await httpClient.post(API_ENDPOINTS.AUTH.GET_USER_TYPE, {
      username,
    });
  },

  login: async (credentials) => {
    return await httpClient.post(API_ENDPOINTS.AUTH.LOGIN, credentials);
  },

  logout: async () => {
    return await httpClient.post(API_ENDPOINTS.AUTH.LOGOUT);
  },

  refreshToken: async () => {
    return await httpClient.post(API_ENDPOINTS.AUTH.REFRESH);
  },

  forgotOtp: async ({ username, email }) => {
    return await httpClient.post(API_ENDPOINTS.AUTH.OTP_INITIATE, {
      username,
      email,
    });
  },

  resetPassword: async (data) => {
    return await httpClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, data);
  },

  verifyOTP: async (data) => {
    return await httpClient.post(API_ENDPOINTS.AUTH.VERIFY_OTP, data);
  },
  changePassword: async (data) => {
    return await httpClient.post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, data);
  },
  resendOtp: async (data) => {
    return await httpClient.post(API_ENDPOINTS.AUTH.RESEND_OTP, data);
  },
  resetPassword: async (data) => {
    return await httpClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, data);
  },

};
